import { T } from './helpers';

export type AIToolScopeStatus = {
    readonly isDisabled: boolean;
};

export const getAIToolDisabledTooltip = () => T._('This AI tool is disabled for this seller.', 'Admin');

export const isAIToolScopeDisabled = (status: AIToolScopeStatus | null | undefined) => status?.isDisabled === true;

export const getDisabledTooltipForScopes = (statuses: Array<AIToolScopeStatus | null | undefined>, requireAllDisabled = false) => {
    const disabled = requireAllDisabled ? statuses.length > 0 && statuses.every(isAIToolScopeDisabled) : statuses.some(isAIToolScopeDisabled);
    return disabled ? getAIToolDisabledTooltip() : undefined;
};

export type AIStudioToolScopeKey = 'image' | 'video' | 'upscaler' | 'model3d';

export const getAIStudioToolScopeKey = (toolId: string): AIStudioToolScopeKey | null => {
    switch (toolId) {
        case 'virtual-tryon':
        case 'product-staging':
        case 'magic-swap':
        case 'multi-image-fusion':
        case 'ad-generator':
            return 'image';
        case 'video-generation':
            return 'video';
        case 'upscaler':
            return 'upscaler';
        case 'text-to-3d':
        case 'image-to-3d':
        case 'multi-views-to-3d':
            return 'model3d';
        default:
            return null;
    }
};
